import React from "react";

// importation style
import "./style.css";

// importation icons
import {
    LoginOutlined,
    PersonAddAltRounded,
    ShoppingCartRounded,
} from "@mui/icons-material";

// iprotation router
import { Link, NavLink } from "react-router-dom";

import { useSelector } from "react-redux";

export default function Navbar() {
    const state = useSelector((state) => state.handleCart);

    const toggle = () => {
        console.log("waa");

        const top = document.querySelector(".top");
        const between = document.querySelector(".between");
        const bottom = document.querySelector(".bottom");

        top.classList.toggle("top-rotate");
        between.classList.toggle("between-width");
        bottom.classList.toggle("bottom-rotate");

        const nav = document.querySelector(".nav-cont");
        nav.classList.toggle("r");
    };

    return (
        <nav className="py-5 fixed top-0 left-0 right-0 bg-white shadow-md">
            <div className="containeer gap-14 mx-auto w-11/12 flex justify-between ">
                <Link className="logo w-48 text-3xl text-bold uppercase" to="/">
                    e-commerce
                </Link>

                <div className="nav-cont bg-white md:h-10 r md:grow md:flex md:static absolute md:w-auto w-full">
                    <ul className="navigation m-auto  md:flex gap-x-5 text-1xl capitalize md:mb-auto mb-4 ">
                        <li className=" flex justify-center items-center">
                            <NavLink to="/">home</NavLink>
                        </li>
                        <li className=" flex justify-center items-center">
                            <NavLink to="/Products">product</NavLink>
                        </li>
                        <li className=" flex justify-center items-center">
                            <NavLink to="1">about</NavLink>
                        </li>
                        <li className=" flex justify-center items-center">
                            <NavLink to="2">contact</NavLink>
                        </li>
                    </ul>

                    <ul className="login_register flex justify-around items-center gap-x-5 text-1xl ">
                        <li>
                            {" "}
                            <a className="flex items-center" href="#">
                                <LoginOutlined /> login
                            </a>
                        </li>
                        <li>
                            {" "}
                            <a className="flex items-center" href="#">
                                <PersonAddAltRounded /> registr
                            </a>
                        </li>
                        <li>
                            <Link
                                to="/cart"
                                className="flex items-center w-36"
                            >
                                <ShoppingCartRounded /> card ({state.length})
                            </Link>
                        </li>
                    </ul>
                </div>

                <div
                    onClick={toggle}
                    className="menu md:hidden flex items-center justify-center w-12 h-12 "
                >
                    <span className="top bg-black"></span>
                    <span className="between bg-black"></span>
                    <span className="bottom bg-black"></span>
                </div>
            </div>
        </nav>
    );
}
